import type { ApiRequestHelpers } from "./useHttpClient";
import type { CollectionResponse, PlatformAnnouncement } from "~/types/api";

export interface AnnouncementPayload {
  type: string;
  title: string;
  description?: string | null;
  cta_label?: string | null;
  cta_url?: string | null;
  image_url?: string | null;
  target_key?: string | null;
  badge_type?: string | null;
  is_active?: boolean;
  target_routes?: string[];
  starts_at?: string | null;
  expires_at?: string | null;
}

export function createAnnouncementApi({ getRequest, postRequest, patchRequest, deleteRequest }: ApiRequestHelpers) {
  const getAnnouncements = () => getRequest<CollectionResponse<PlatformAnnouncement>>("/announcements");

  const dismissAnnouncement = (id: string) => postRequest<void>(`/announcements/${id}/dismiss`);

  const adminListAnnouncements = () => getRequest<CollectionResponse<PlatformAnnouncement>>("/announcements/admin");

  const adminCreateAnnouncement = (data: AnnouncementPayload) =>
    postRequest<{ data: PlatformAnnouncement }>("/announcements/admin", data);

  const adminUpdateAnnouncement = (id: string, data: Partial<AnnouncementPayload>) =>
    patchRequest<{ data: PlatformAnnouncement }>(`/announcements/admin/${id}`, data);

  const adminDeleteAnnouncement = (id: string) => deleteRequest<void>(`/announcements/admin/${id}`);

  return {
    getAnnouncements,
    dismissAnnouncement,
    adminListAnnouncements,
    adminCreateAnnouncement,
    adminUpdateAnnouncement,
    adminDeleteAnnouncement,
  };
}

export type AnnouncementApi = ReturnType<typeof createAnnouncementApi>;
